import { Box, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { colors } from "../../utils/colors";
import { FinancialExportStyles } from "./styles";

interface DatePickerFieldProps {
  label: string;
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  onAccept: (newValue: Dayjs | null) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  ariaLabel: string;
  minDate?: Dayjs | null;
  maxDate?: Dayjs | null;
}

const DatePickerField = ({
  label,
  value,
  onChange,
  onAccept,
  isOpen,
  setIsOpen,
  ariaLabel,
  minDate,
  maxDate,
}: DatePickerFieldProps) => {
  const handleClose = () => {
    const input = document.querySelector(
      `input[aria-label="${ariaLabel}"]`
    ) as HTMLInputElement;
    if (input) {
      input.blur();
    }
    if (
      document.activeElement &&
      document.activeElement instanceof HTMLElement
    ) {
      document.activeElement.blur();
    }
    setIsOpen(false);
  };

  const getSectionColor = (value: Dayjs | null) => {
    return value ? colors.grayish_blue : colors.placeholder_grey;
  };

  const getBorderColor = (open: boolean) =>
    open ? colors.filter_red : colors.border_gray;

  const sixMonthsAgo = dayjs().subtract(6, "month");
  const isMinDateValid = minDate?.isAfter(sixMonthsAgo) === true;
  const calculatedMinDate = isMinDateValid ? minDate : sixMonthsAgo;
  const calculatedMaxDate = maxDate ?? dayjs();

  return (
    <Box sx={FinancialExportStyles.filterInputWidth}>
      <Typography variant="h6" sx={FinancialExportStyles.datePickerLabel}>
        {label}
      </Typography>
      <DatePicker
        open={isOpen}
        onClose={handleClose}
        onAccept={onAccept}
        value={value}
        onChange={onChange}
        format="DD/MM/YYYY"
        minDate={calculatedMinDate}
        maxDate={calculatedMaxDate}
        selectedSections={null}
        slotProps={{
          textField: {
            placeholder: "DD/MM/YYYY",
            size: "small",
            "aria-label": ariaLabel,
            onClick: () => {
              if (!isOpen) {
                setIsOpen(true);
              }
            },
            onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
              if (!isOpen) {
                e.target.blur();
              }
            },
            InputProps: {
              endAdornment: (
                <Box sx={FinancialExportStyles.calendarIconWrapper}>
                  <CalendarMonthOutlinedIcon
                    sx={FinancialExportStyles.calendarMonthIcon}
                  />
                </Box>
              ),
              readOnly: true,
              sx: FinancialExportStyles.inputPropsStyle,
            },
            inputProps: FinancialExportStyles.inputBaseStyle,
            sx: FinancialExportStyles.textFieldStyle(
              isOpen,
              value,
              getBorderColor,
              getSectionColor
            ),
          },
        }}
      />
    </Box>
  );
};

export default DatePickerField;
